<template>
  <div  class="row">
    <div class="btn form-control btn-outline-danger" disabled>
      <span class="spinner-grow spinner-grow-sm"></span>
      بارگذاری...
    </div>
  </div>
</template>



